import analystService from "../../components/Services/analyst.service";
import { GET_ALL_TRADERS, GET_SPECEFIC_TRADER } from "./types";

export const getAllTraders = () => async (dispatch) => {
  analystService
    .getAllTraders()
    .then((res) => {
      dispatch({ type: GET_ALL_TRADERS, payload: res?.data?.data });
    })
    .catch((err) => console.log(err));
};

export const getSpeceficTraders = (id) => async (dispatch) => {
  analystService
    .getSpeceficTrader(id)
    .then((res) => {
      dispatch({ type: GET_SPECEFIC_TRADER, payload: res?.data?.data });
    })
    .catch((err) => console.log(err));
};

export const getSpeceficTradersNew = (id) => async (dispatch) => {
  analystService
    .getSpeceficTraderNew(id)
    .then((res) => {
      dispatch({ type: GET_SPECEFIC_TRADER, payload: res?.data?.data });
    })
    .catch((err) => console.log(err));
};
